import React from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

const PatientCallsEmptyState = () => {
  const { t } = useTranslation();

  return (
    <div style={{ marginTop: 30}}>
      <Empty
        image="https://img.icons8.com/plasticine/100/phone-office.png"
        description={t('patient_details.no_calls')}
      />
    </div>
  );
};

export default PatientCallsEmptyState;